import { useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { setAuthContext } from '../utils/axiosConfig';

const AuthProviderWrapper = ({ children }) => {
  const authContext = useAuth();

  useEffect(() => {
    // Set the auth context reference for axios interceptor
    setAuthContext(authContext);
  }, [authContext]);

  return children;
};

export default AuthProviderWrapper;
